<template>
    <div class="board_graph_list">
        <Chart style="height: 150px" v-for="data in chartData.active" :defaultLayout="activeChartLayout" :data="data"></Chart>
        <Chart style="height: 380px" v-for="data in chartData.platform" :defaultLayout="platformChartLayout" :data="data"></Chart>
        <Chart style="height: 380px" v-for="data in chartData.gubun" :defaultLayout="gubunChartLayout" :data="data"></Chart>
        <Chart style="height: 380px" v-for="data in chartData.industry" :defaultLayout="industryChartLayout" :data="data"></Chart>
        <Chart style="height: 150px" v-for="data in chartData.doubt" :defaultLayout="doubtChartLayout" :data="data"></Chart>
    </div>
</template>

<script lang="ts" config>
    import {
        Chart,
        numberFormat,
        reactive,
        LayoutOption,
        watch,
        Spinner,
        onMounted,
        ChartSort,
        ChartData,
        setChartData,
    } from "@/BaseComponent";
    import { setPercentChart } from "@/services/commonUtils";
    export default {
        props: ["chartData", "loading"],
        components: {
            Chart,
            Spinner,
        },
        setup(props: any) {
            const state = reactive({
                isLoading: true,
            });

            const chartData = reactive({
                platform: [] as ChartData[],
                gubun: [] as ChartData[],
                industry: [] as ChartData[],
                active: [] as ChartData[],
                doubt: [] as ChartData[],
            });

            const activeChartLayout = reactive({
                type: "percent",
                title: { text: "활성화 여부" },

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부

                isRowChart: true,
                grid: { top: "19%" },
            } as LayoutOption);

            const doubtChartLayout = reactive({
                type: "percent",
                title: { text: "그루밍 성착취 의심" },

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부

                isRowChart: true,
                grid: { top: "19%" },
            } as LayoutOption);

            const platformChartLayout = reactive({
                type: "bar",
                xAxisKey: "",
                title: { text: "채팅방 수" },

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부

                isRowChart: true,
            } as LayoutOption);

            const gubunChartLayout = reactive({
                type: "bar",
                xAxisKey: "",
                title: { text: "채팅방 구분" },

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부

                isRowChart: true,

                grid: { left: "15%" },
            } as LayoutOption);

            const industryChartLayout = reactive({
                type: "bar",
                xAxisKey: "",
                title: { text: "채팅방 업종" },

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부

                isRowChart: true,

                grid: { left: "15%" },
            } as LayoutOption);

            const activeChartSort = [
                { name: "활성화", valueKey: "cntActive", stack: "활성화 여부" },
                { name: "비활성화", valueKey: "cntInactive", stack: "활성화 여부" },
            ] as ChartSort[];
            const doubtChartSort = [
                { name: "그루밍 O", valueKey: "cntDoubtOk", stack: "그루밍 성착취 의심" },
                { name: "그루밍 X", valueKey: "cntDoubtNo", stack: "그루밍 성착취 의심" },
            ] as ChartSort[];

            const platformChartSort = [
                { name: "기타", valueKey: "cntEtc" },
                { name: "카카오톡", valueKey: "cntKakaoTalk" },
                { name: "디스코드", valueKey: "cntDiscord" },
                { name: "텔레그램", valueKey: "cntTelegram" },
            ] as ChartSort[];

            const gubunChartSort = [
                { name: "기타 커뮤니티", valueKey: "cnt", valueIdx: 9 },
                { name: "성적 대화 공유", valueKey: "cnt", valueIdx: 8 },
                { name: "성적 대상화 콘텐츠 공유", valueKey: "cnt", valueIdx: 7 },
                { name: "성매매 관련 커뮤니티", valueKey: "cnt", valueIdx: 6 },
                { name: "성매수 후기 공유", valueKey: "cnt", valueIdx: 5 },
                { name: "성매매알선포털사이트 주소 알림", valueKey: "cnt", valueIdx: 4 },
                { name: "성매매 업소 광고 알림", valueKey: "cnt", valueIdx: 3 },
                { name: "성매매 업소 예약관리 및 광고", valueKey: "cnt", valueIdx: 2 },
                { name: "성매매 업소 광고 대행", valueKey: "cnt", valueIdx: 1 },
            ] as ChartSort[];

            const industryChartSort = [
                { name: "해당없음", valueKey: "cnt", valueIdx: 11 },
                { name: "기타", valueKey: "cnt", valueIdx: 10 },
                { name: "해외 성매매 알선", valueKey: "cnt", valueIdx: 7 },
                { name: "출장마사지 알선 사이트", valueKey: "cnt", valueIdx: 5 },
                { name: "성매수자 커뮤니티", valueKey: "cnt", valueIdx: 9 },
                { name: "성매매알선포털사이트", valueKey: "cnt", valueIdx: 8 },
                { name: "휴게텔", valueKey: "cnt", valueIdx: 6 },
                { name: "키스방", valueKey: "cnt", valueIdx: 4 },
                { name: "유흥주점", valueKey: "cnt", valueIdx: 3 },
                { name: "오피", valueKey: "cnt", valueIdx: 2 },
                { name: "마사지", valueKey: "cnt", valueIdx: 1 },
            ] as ChartSort[];

            onMounted(() => {
                if (props.chartData) setData(props.chartData);
            });

            watch(
                () => props.chartData,
                (newValue) => {
                    if (newValue) setData(newValue);
                },
                { deep: true },
            );

            const setData = (data: any) => {
                init();
                chartData.active.push(setPercentChart(activeChartSort, data));
                chartData.doubt.push(setPercentChart(doubtChartSort, data));
                chartData.platform.push(setChartData(platformChartSort, data, platformChartLayout.xAxisKey));
                chartData.gubun.push(setChartData(gubunChartSort, data.gubunList, gubunChartLayout.xAxisKey));
                chartData.industry.push(setChartData(industryChartSort, data.industryList, industryChartLayout.xAxisKey));
            };

            const init = () => {
                chartData.platform = [];
                chartData.gubun = [];
                chartData.industry = [];
                chartData.active = [];
                chartData.doubt = [];
            };

            return {
                props,
                state,
                chartData,
                platformChartLayout,
                gubunChartLayout,
                industryChartLayout,
                activeChartLayout,
                doubtChartLayout,
                numberFormat,
            };
        },
    };
</script>

<style scoped>
    .dp__input {
        width: 15%;
    }
    .board_graph_top {
        display: flex;
        gap: 20px;
    }
    .board_btn.board_ico_btn.active {
        background-color: var(--lightBlue) !important;
        color: #ffffff !important;
    }
    #board_layer .sch_box {
        height: 45px;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;

        border: 1px solid #dfdfdf;
        height: auto;
    }
    .board_graph_list {
        padding-top: 20px;
    }
</style>
